/** Шаблоны протоколов ЭГДС / колоноскопии — макет как у бланка эндоскописта. */

export const ENDOSCOPY_KIND_EGDS = 'egds';
export const ENDOSCOPY_KIND_COLONOSCOPY = 'colonoscopy';

export const DEFAULT_EGDS_ANESTHESIA = 'Sol.Lidocaini 10% - спрей';
export const DEFAULT_NARCOSIS_ANESTHESIA = 'наркоз';
export const DEFAULT_GENERAL_ANESTHESIA = 'общий наркоз';

export const EGDS_DEFAULT_FINDINGS = [
  'Пищевод свободно проходим, просвет пищевода не деформирован, при инсуффляции расправляется хорошо, слизистая оболочка пищевода розовая, блестящая. Уровень пищеводного отверстия диафрагмы расположен на 38 см от резцов.',
  'В просвете желудка умеренное количество желчи со слизью. Складки среднего размера, эластичные, полностью расправляются воздухом. Перистальтика сохранена. Слизистая бледная, гладкая, эластичная, в антральном отделе очагово гиперемирована. Складки слизистой выражены, продольно направлены, извиты, полностью расправляются при инсуффляции. В антральном отделе по большой кривизне визуализируется единичная эрозия, в дно гиперемировано.',
  'Привратник не деформирован, смыкается полностью, свободно проходим, через него периодически определяется заброс желчи в просвет желудка.',
  'Луковица двенадцатиперстной кишки не деформирована, овальной формы, слизистая оболочка розовая, бархатистая. Постбульбарные отделы свободно проходимы, слизистая оболочка гиперемирована. БДС не визуализируется.',
].join('\n\n');

export const EGDS_DEFAULT_CONCLUSION =
  'Недостаточность кардии. Эрозивный гастрит. Дуодено-гастральный рефлюкс. Дуоденит.';

export const COLONOSCOPY_DEFAULT_FINDINGS = [
  'Аппарат свободно проведён до купола слепой кишки. Просвет кишки не деформирован, при инсуффляции расправляется хорошо.',
  'Слизистая оболочка розовая, блестящая, сосудистый рисунок сохранён. Гаустры выражены. Складки эластичные.',
  'Патологических образований, язв, эрозий, кровотечений не выявлено. Баугиниева заслонка сомкнута, свободно проходима.',
].join('\n\n');

export const COLONOSCOPY_DEFAULT_CONCLUSION = 'Органической патологии толстой кишки не выявлено.';

export const ENDOSCOPY_PROTOCOL_TEMPLATES = {
  [ENDOSCOPY_KIND_EGDS]: {
    id: ENDOSCOPY_KIND_EGDS,
    title: 'ЭЗОФАГОГАСТРОДУОДЕНОСКОПИЯ',
    findings: EGDS_DEFAULT_FINDINGS,
    conclusion: EGDS_DEFAULT_CONCLUSION,
  },
  [ENDOSCOPY_KIND_COLONOSCOPY]: {
    id: ENDOSCOPY_KIND_COLONOSCOPY,
    title: 'КОЛОНОСКОПИЯ',
    findings: COLONOSCOPY_DEFAULT_FINDINGS,
    conclusion: COLONOSCOPY_DEFAULT_CONCLUSION,
  },
};

export function resolveEndoscopyKind(serviceName = '') {
  const name = String(serviceName || '').toLowerCase();
  if (/колоноскоп|colonoscop/.test(name)) return ENDOSCOPY_KIND_COLONOSCOPY;
  return ENDOSCOPY_KIND_EGDS;
}

export function getEndoscopyProtocolTemplate(serviceName = '') {
  const kind = resolveEndoscopyKind(serviceName);
  return ENDOSCOPY_PROTOCOL_TEMPLATES[kind] || ENDOSCOPY_PROTOCOL_TEMPLATES[ENDOSCOPY_KIND_EGDS];
}

export function defaultEndoscopyAnesthesia(serviceName = '') {
  const name = String(serviceName || '').toLowerCase();
  if (/общий\s*наркоз/.test(name)) return DEFAULT_GENERAL_ANESTHESIA;
  if (/наркоз|sedation|anesthes/.test(name)) return DEFAULT_NARCOSIS_ANESTHESIA;
  return DEFAULT_EGDS_ANESTHESIA;
}
